var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwiperArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 40",
    width: "32px",
    height: "40px",
    className: "img-fluid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(241, 52, 51)",
    d: "M-0.000,19.992 L32.000,-0.008 L32.000,39.992 L-0.000,19.992 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperArrows);
export default __webpack_public_path__ + "static/media/swiper_arrows.aa3546f47fe70f596295ac9615918049.svg";
export { ForwardRef as ReactComponent };